import { useCallback } from 'react';

import { ACCOUNT_NUMBER_DEFAULT_VALUE } from 'appConstants';
import { Customers } from 'components';
import { useField } from 'formik';

import type { ICustomersField } from './types';

export default function CustomersField({
  name,
  referenceKey,
  disabled,
  disableOption,
  onChange,
  textFieldProps,
  productType,
  showFrequentCustomers,
}: ICustomersField) {
  const [{ value }, , { setValue }] = useField(name);
  const [, metaId, { setTouched }] = useField(`${name}.${referenceKey}`);

  const hasError = Boolean(metaId.touched && metaId.error);
  const helperText = hasError ? metaId.error : '';

  const handleOnBlur = useCallback(async () => {
    if (!metaId.touched) await setTouched(true, false);
  }, [setTouched, metaId.touched]);

  const handleOnChange = useCallback(
    async (option) => {
      if (onChange) {
        onChange(option);
      } else {
        await setValue(option || ACCOUNT_NUMBER_DEFAULT_VALUE, true);
      }
    },
    [onChange, setValue],
  );

  return (
    <Customers
      data-testid={`customer-details-${name}`}
      disabled={disabled}
      textFieldProps={{
        name,
        error: hasError,
        helperText,
        onBlur: handleOnBlur,
        ...textFieldProps,
      }}
      selectedCustomer={value && value.customerReference ? value : null}
      onChange={handleOnChange}
      getOptionDisabled={disableOption}
      productType={productType}
      showFrequentCustomers={showFrequentCustomers}
    />
  );
}
